import { render, staticRenderFns } from "./DataList.vue?vue&type=template&id=58d891a1&scoped=true&"
import script from "./DataList.vue?vue&type=script&lang=ts&"
export * from "./DataList.vue?vue&type=script&lang=ts&"
import style0 from "./DataList.vue?vue&type=style&index=0&id=58d891a1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d891a1",
  null
  
)

export default component.exports